import { createContext } from "react";

const bookingContext = createContext();

export default bookingContext;